var DiscountJs = (function ($) {
     var addToggleDiscountButtonAction = function(toggleDiscountButton, selector) {
        toggleDiscountButton.on('click', function(e) {
           e.preventDefault();
           toggleDiscountButton.hide();
           $(selector).show();
        });
     };
     var addSubmitDiscountButtonAction = function(submitAdacButton, varName, selector, errorSelector, uri) {
        submitAdacButton.on('click', function(e) {
           e.preventDefault();
           postAdacNo(varName, selector, errorSelector, uri);
        });
     };
     var postAdacNo = function (varName, selector, errorSelector, uri){
     var token = $("input[name='_csrf']").val();
     var header = "X-CSRF-TOKEN";
     var data = {}
     data[varName] = $(selector).val();
     $.ajax({
             url: '/submit/' + uri,
             type: 'POST',
             data: data,
             beforeSend: function(xhr) {
                xhr.setRequestHeader(header, token);
             },
             contentType: 'application/x-www-form-urlencoded; charset=utf-8',
             success: function (response) {
                 window.location.reload();
             },
             error: function (xhr, status, error) {
                $(errorSelector).show();
             }
     });
     }
    return {
        addToggleDiscountButtonAction : addToggleDiscountButtonAction,
        addSubmitDiscountButtonAction : addSubmitDiscountButtonAction
     }
}) (jQuery);

function resetDiscounts() {
    $(".adacContainer").hide();
    $(".oamtcContainer").hide();
    $(".voucherContainer").hide();
    $(".adac-discount-label").removeClass('active');
    $(".oamtc-discount-label").removeClass('active');
    $(".voucher-discount-label").removeClass('active');
}

$(document).ready(function () {
    var toggleAdacButton = $(".toggleAdacButton a");
    var submitAdacButton = $("#adac-submit-button");

    var toggleOamtcButton = $(".toggleOamtcButton a");
    var submitOamtcButton = $("#oamtc-submit-button");

    if (typeof toggleAdacButton !== 'undefined'  && typeof submitAdacButton !== 'undefined' ) {
        DiscountJs.addToggleDiscountButtonAction(toggleAdacButton, '#adac-container');
        DiscountJs.addSubmitDiscountButtonAction(submitAdacButton, 'adacNo', '#adacNo', '#adac-error', 'adac');
    }
    if (typeof toggleOamtcButton !== 'undefined'  && typeof submitOamtcButton !== 'undefined' ) {
        DiscountJs.addToggleDiscountButtonAction(toggleOamtcButton, '#oamtc-container');
        DiscountJs.addSubmitDiscountButtonAction(submitOamtcButton, 'oamtcNo', '#oamtcNo', '#oamtc-error', 'oamtc');
    }
    $(".toggleClubMemberVoucherButton").on('click', function (e) {
        e.preventDefault();
        $(".clubMemberVoucherButtonContainer").toggle();
    });
    $("#adac-discount-radio-button").on('click', function(){
        resetDiscounts();
        $(".adacContainer").show();
        $(".toggleAdacButton").hide();
        $("#adac-container").show();
        $(".adac-discount-label").addClass('active');
    });
    $("#oamtc-discount-radio-button").on('click', function(){
        resetDiscounts();
        $(".oamtcContainer").show();
        $(".toggleOamtcButton").hide();
        $("#oamtc-container").show();
        $(".oamtc-discount-label").addClass('active');
    });
    $("#voucher-discount-radio-button").on('click', function(){
        resetDiscounts();
        $(".voucherContainer").show();
        $(".toggleVoucherButton").hide();
        $(".mySmartLayout").show();
        $(".voucher-discount-label").addClass('active');
    });
});